
export interface single_event_expenses_report_line_RowInterface {
  event_title: string;
  employee_name: string;
  claim_id: string;
  claim_item_name: string;
  branch_name: string;
  doc_currency_code: string;
  claim_amount_incl_tax: number;
  claim_status: string;
}

export class single_event_expenses_report_line_RowClass implements single_event_expenses_report_line_RowInterface {
  event_title: string;
  employee_name: string;
  claim_id: string;
  claim_item_name: string;
  branch_name: string;
  doc_currency_code: string;
  claim_amount_incl_tax: number;
  claim_status: string;
}
